var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100 confirmation-page home" }, [
    _c("div", { staticClass: "row mx-0" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 mb-3 text-center text-white product-section-heading",
              class: { error: _vm.isBindError }
            },
            [
              _c("div", { staticClass: "row no-gutters" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "col-10 pr-2 text-left" }, [
                  _c("h1", { staticClass: "title-banner m-0" }, [
                    _vm._v(_vm._s(_vm.pageTitle))
                  ])
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "carrier-logo-property my-3",
              class: {
                "col-12 text-center py-0 min-height align-items-center":
                  _vm.isBindError,
                "col-6": !_vm.isBindError
              }
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.logoPathSvg,
                  alt: "NW",
                  width: "180.763px",
                  height: "auto"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-6",
              class: { "show my-3": !_vm.isBindError, hide: _vm.isBindError }
            },
            _vm._l(_vm.pageData.fields, function(group, i) {
              return group.section !== "Next Steps"
                ? _c(
                    "div",
                    { key: i, staticClass: "row" },
                    [
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-6 mb-2 font-weight-bold label-name"
                          },
                          [_vm._v(_vm._s(group["label"]))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 mb-2" }, [
                          _vm._v(_vm._s(group["field_value"]))
                        ])
                      ]
                    ],
                    2
                  )
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 p-0" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "shadow-sm rounded" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "py-2 pl-3 mb-2 text-white  product-section-heading rounded-top",
                      attrs: { role: "heading", "aria-level": "3" }
                    },
                    [_vm._v("\n                  Next steps\n                ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mx-0 pt-8 px-3 pb-2 next-step-row" },
                    [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.nextSteps) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.docLabel
                    ? _c("div", { staticClass: "pl-2" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary select-carrier-btn mb-2",
                            attrs: {
                              type: "button",
                              tabindex: "0",
                              role: "button"
                            },
                            on: {
                              click: function($event) {
                                return _vm.continueToLink()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.docLabel) +
                                "\n                    "
                            ),
                            _c("i", { staticClass: "fa fa-open-in-new ml-1" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "currentColor"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z",
                                      fill: "currentColor"
                                    }
                                  })
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.homePropCov.length > 0 || _vm.homePropEndsmt.length > 0
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "mt-3 col-12 p-0 shadow-sm rounded" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "py-2 pl-3 mb-2 text-white product-section-heading rounded-top"
                    },
                    [_vm._v("\n            Coverage Summary\n          ")]
                  ),
                  _vm._v(" "),
                  _vm.homePropCov.length > 0
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "py-1 pl-3 mb-2 text-grey-dark bg-faint-gray",
                            attrs: { role: "heading", "aria-level": "4" }
                          },
                          [_vm._v("Property Coverages")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.homePropCov, function(pData, pKey) {
                          return [
                            _c(
                              "div",
                              {
                                key: pKey + "homePropCov",
                                staticClass: "row mx-0 mb-2"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray"
                                  },
                                  [_vm._v(_vm._s(pData.label))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 col-md-8 col-xl-6 text-dark-gray"
                                  },
                                  [_vm._v(_vm._s(pData.text))]
                                )
                              ]
                            )
                          ]
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.homePropEndsmt.length > 0
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "py-1 pl-3 mt-3 text-grey-dark bg-faint-gray",
                            attrs: { role: "heading", "aria-level": "4" }
                          },
                          [_vm._v("Property Endorsement")]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.homePropEndsmt, function(propData, propKey) {
                          return [
                            _c(
                              "div",
                              {
                                key: propKey + "propKey",
                                staticClass: "row mx-0 mb-2"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray"
                                  },
                                  [_vm._v(_vm._s(propData.label))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 col-md-8 col-xl-6 text-dark-gray"
                                  },
                                  [_vm._v(_vm._s(propData.text))]
                                )
                              ]
                            )
                          ]
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _vm.footerNote() ? _c("hr") : _vm._e(),
    _vm._v(" "),
    _vm.footerNote()
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center mx-auto mt-3" },
          [
            _c(
              "div",
              {
                staticClass: "alert alert-primary my-0 py-2 w-50",
                attrs: { role: "note" }
              },
              [
                _c("div", { staticClass: "row no-gutters" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col d-inline-block my-auto smaller-font-content"
                    },
                    [_vm._v(_vm._s(_vm.footerNote()))]
                  )
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 policy-type" }, [
      _c("span", { staticClass: "fas fa-home" }),
      _vm._v(" Home\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21ffada0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21ffada0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/HomeConfirmation.vue
// module id = null
// module chunks = 